import { render, staticRenderFns } from "./CircleProgressBar.vue?vue&type=template&id=488d0ca2&scoped=true&"
import script from "./CircleProgressBar.vue?vue&type=script&lang=js&"
export * from "./CircleProgressBar.vue?vue&type=script&lang=js&"
import style0 from "./CircleProgressBar.vue?vue&type=style&index=0&id=488d0ca2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "488d0ca2",
  null
  
)

export default component.exports